export const DATA_HOOKS = {
    actionButton: 'tag-list-action',
    toggleMoreButton: 'tag-list-toggle-more',
};
//# sourceMappingURL=TagList.constants.js.map